export enum DeviceProperties {
  Name = 'name',
  Account = 'account',
  DeviceType = 'deviceType',
  Profiles = 'profiles',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Banned = 'banned',
  Active = 'active',
  IsMobile = 'isMobile',
  BrowserName = 'browserName',
  MajorVersion = 'majorVersion',
  FullVersion = 'fullVersion',
  UserAgent = 'userAgent',
  AppName = 'appName',
  OS = 'oS',
  LocalDeviceId = 'localDeviceId',
  ModelName = 'modelName',
  DesignName = 'designName',
  OSName = 'oSName',
  ProductName = 'productName',
  Brand = 'brand',
  TotalMemory = 'totalMemory',
  OSInternalBuildId = 'oSInternalBuildId',
  ModelId = 'modelId',
  Token = 'token',
  OSVersion = 'oSVersion',
  OSBuildFingerPrint = 'oSBuildFingerPrint',
  OSBuildId = 'oSBuildId',
  DeviceYearClass = 'deviceYearClass',
  PlatformApiLevel = 'platformApiLevel',
  Manufacturer = 'manufacturer',
  XForwardedFor = 'xForwardedFor',
  XAppengineUserIp = 'xAppengineUserIp',
  FastlyClientIp = 'fastlyClientIp',
}
export enum DeviceMetaProperties {
  AccountId = 'Account-id',
  AccountVersion = 'Account-version',
  ProfilesId = 'Profiles-id',
  ProfilesVersion = 'Profiles-version',
}
